import {envConfig} from "../configuration/Configuration";
import { CookieHelper } from "./CookieHelper";

class LanguageHelper {
    private detectedLanguage: string;

    public constructor() {
        this.detectedLanguage = this.DetectCurrentLanguage();
    }

    public GetCurrentLanguage() {
        return this.detectedLanguage;
    }

    private getParentUrl() {
        if (envConfig.Environment === "local") {
            return document.URL;
        }
        else
        {
            const referrer = document.referrer;
            if (referrer && referrer.startsWith("https://www.skype.com/")) {
                return referrer;
            }
            else {
                return null;
            }
        }
    }

    private DetectCurrentLanguage() : string {

        const failbackLanguage: string = "en-US";
        let languageToReturn: string = "en-US";

        const cookie : any | string = CookieHelper.getCookieValue(envConfig.Cookies.skype, "LC");
        if (cookie && typeof(cookie) === "string") {
            languageToReturn = cookie;
        }

        const parentUrl = this.getParentUrl();
        if (parentUrl) {
            var parts = parentUrl.split('/');
            if (parts && parts.length >= 4) {
                languageToReturn = parts[3];
              }
        }

        if (envConfig.Languages.SupportedLanguages.indexOf(languageToReturn) >= 0) {
            return languageToReturn;
        } else {
            // language we found is not in list, so try to find mapping
            const mapped: string = envConfig.Languages.LanguagesMapping[languageToReturn];
            if (mapped) {
                return mapped;
            } else {
                return failbackLanguage;
            }
        }
    }

}

export const languageHelper = new LanguageHelper();